<!--
 * @Description: 邮箱修改
 * @Version: 2.0
 * @Autor: Lianzhidong
 * @Date: 2022-03-12 21:00:42
 * @LastEditors: Lianzhidong
 * @LastEditTime: 2022-03-12 21:04:27
-->
<template>
  <div class="email">
    <el-descriptions direction="vertical" :column="1" border>
      <el-descriptions-item label="新邮箱">
        <el-input v-model="param.email" placeholder="请输入新邮箱"></el-input>
      </el-descriptions-item>
    </el-descriptions>
    <div class="phone-btn">
      <el-button type="primary" @click="onSubmit" :loading="isLoading">
        确认修改</el-button
      >
    </div>
  </div>
</template>

<script>
import HTTP_USER from "@/api/user";
export default {
  name: "Email",
  data() {
    return {
      param: {
        email: "",
      },
      isLoading: false,
    };
  },
  methods: {
    async onSubmit() {
      if (this.param.email.length === 0) {
        this.$message.warning("请输入新邮箱地址");
        return;
      }
      this.isLoading = true;
      try {
        const res = await HTTP_USER.updateEmailAndPhone(this.param);
        this.isLoading = false;
        if (res.code === 200) {
          this.$message.success("修改成功");
          this.param = {
            email: "",
          };
        } else {
          this.$message.error(
            typeof res.msg === "string" ? res.msg : "请求出错，请联系管理员"
          );
        }
      } catch (e) {
        console.error(e);
        this.isLoading = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.phone {
  padding: 5px;
  &-btn {
    margin-top: 20px;
    display: flex;
    justify-content: center;
  }
}
</style>
